export const iconFontAwesomeNatureLocust = (
	<i className="fa-solid fa-locust"></i>
);
